<template>
  <div v-if="loading"  class="loader pt-100 mt-80">
    <b-spinner label="Spinning" variant="primary"></b-spinner>
  </div>
  <div class="ml-220 mt-80 position-relative" v-else>
    <b-alert
      :show="dismissCountDown"
      fade
      variant="success"
      class="success-alert"
      style="width: 200px; margin-bottom: 0;"
      @dismiss-count-down="countDownChanged"
    >
      Обновленно
    </b-alert>
    <form @submit.prevent="updateSkypePrice">
      <div class="form-elems mb-5">
        <h4 class="mt-4 mb-1">Индивидуальная консультация по скайпу</h4>
        <div class="d-flex w-100 mb-2">
          <input
            name="price1"
            :state="validateState('price1')"
            v-validate="'required'"
            type="text"
            class="price-input mr-2"
            v-model="price1"
            placeholder="Цена 1">
          <input
            name="time1"
            :state="validateState('time1')"
            v-validate="'required'"
            type="text"
            class="price-input"
            v-model="time1"
            placeholder="Время 1">
        </div>
        <div class="d-flex w-100">
          <input
            name="price2"
            :state="validateState('price2')"
            v-validate="'required'"
            type="text"
            class="price-input mr-2"
            v-model="price2"
            placeholder="Цена 2">
          <input
            name="time2"
            :state="validateState('time2')"
            v-validate="'required'"
            type="text"
            class="price-input"
            v-model="time2"
            placeholder="Время 2">
        </div>
        <button type="submit" class="type-submit d-block">Обновить цену</button>
      </div>
    </form>
    <form @submit.prevent="updateConsultationPrice">
      <div class="form-elems mb-5">
        <h4>Индивидуальная консультация по переписке</h4>
        <div class="d-flex w-100">
          <input
            name="price3"
            :state="validateState('price3')"
            v-validate="'required'"
            type="text"
            class="price-input"
            v-model="price3"
            placeholder="Цена">
        </div>
        <button type="submit" class="type-submit d-block">Обновить цену</button>
      </div>
    </form>
    <form @submit.prevent="updateThreeDaysPrice">
      <div class="form-elems">
        <h4>Переписка в течение 3 дней</h4>
        <div class="d-flex w-100">
          <input
            name="price4"
            :state="validateState('price4')"
            v-validate="'required'"
            type="text"
            class="price-input"
            v-model="price4"
            placeholder="Цена">
        </div>
        <button type="submit" class="type-submit d-block">Обновить цену</button>
      </div>
    </form>
  </div>
</template>

<script>
  import validate from '@/mixins/validate';
  import {mapState, mapActions} from 'vuex'
  export default {
    name: "AdminPricePage",
    mixins: [validate],
    data() {
      return {
        loading: true,
        price1: null,
        time1: null,
        price2: null,
        time2: null,
        price3: null,
        price4: null,
        dismissCountDown: 0
      }
    },
    computed: {
      ...mapState('price', ['skype', 'consultation', 'threeDays'])
    },
    async mounted() {
      await this.loadDetails()
    },
    methods: {
      ...mapActions('price', [
        'fetchSkypeConsultation', 'fetchChatConsultation', 'fetchThreeDaysConsultation',
        'skypeConsultation', 'chatConsultation', 'threeDaysConsultation']),
      async loadDetails() {
        this.loading = true
        await this.fetchSkypeConsultation()
        this.price1 = this.skype.price1
        this.time1 = this.skype.time1
        this.price2 = this.skype.price2
        this.time2 = this.skype.time2
        await this.fetchChatConsultation()
        this.price3 = this.consultation.price
        await this.fetchThreeDaysConsultation()
        this.price4 = this.threeDays.price
        this.loading = false
      },
      async updateSkypePrice() {
        this.$validator.validateAll().then(async v => {
          if(!v) return
          try {
            await this.skypeConsultation({price1: this.price1, time1: this.time1, price2: this.price2, time2: this.time2})
            this.dismissCountDown = 2
          } catch (e) {
            throw e
          }
        })
      },
      async updateConsultationPrice() {
        this.$validator.validateAll().then(async v => {
          if(!v) return
          try {
            await this.chatConsultation(this.price3)
            this.dismissCountDown = 2
          } catch (e) {
            throw e
          }
        })
      },
      async updateThreeDaysPrice() {
        this.$validator.validateAll().then( async v => {
          if(!v) return
          try {
            await this.threeDaysConsultation(this.price4)
            this.dismissCountDown = 2
          } catch (e) {
            throw e
          }
        })
      },
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
    }
  }
</script>

<style lang="scss">
    form {
      .form-elems {
        .price-input {
          width: 200px;
          padding: 5px 10px!important;
        }
      }
    }
.success-alert {
  position: absolute !important;
  right: 0;
  text-align: center;
}
</style>